<template>
  <div>
    <page-header
      :title="title"
      :container-class="containerClass"
      :info-text="'Select date range with program to fetch respective analytics'"
    />
    <div :class="containerClass"></div>
    <div class="page-section border-bottom-2">
      <div :class="containerClass">
        <div class="mt-3">
          <div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5>Filter by Date(s)</h5>
                </div>

                <div>
                  <date-picker
                    v-model="filters.dateRange"
                    format="MMMM DD, YYYY"
                    valueType="YYYY-MM-DD"
                    style="width: 100%"
                    id="date"
                    lang="en"
                    placeholder="Filter by Start Date - End Date Range"
                    range
                    class="w-100 mb-3"
                    :input-attr="{ required: 'true' }"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <h5>Filter by Program</h5>
                </div>
                <div>
                  <v-select
                    id="programs"
                    class="form-control v-select-custom"
                    label="title"
                    v-model="filters.program"
                    :reduce="item => item.id"
                    placeholder="All Programs"
                    :options="allPrograms"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" :required="!filters.program" v-bind="attributes" v-on="events" />
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex align-items-center">
                        <fmv-avatar :title="true" title-class="bg-transparent" rounded no-link slot="aside" size="xs">
                          <b-img :src="option.image" class="img-fluid" width="20" alt="Logo" v-if="option.image" />
                          <md-icon v-else>local_library</md-icon>
                        </fmv-avatar>
                        <span>{{ option.title }}</span>
                      </div>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback :state="isProgramEmpty ? false : null"
                    >This field is required.</b-form-invalid-feedback
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <page-separator>
          <b-link v-b-toggle="'registeration-over-time-section'" class="accordion__toggle p-0">
            <span class="flex">Registrations Over Time</span>
            <md-icon class="accordion__toggle-icon">
              {{ registerOverTimeVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </md-icon>
          </b-link>
        </page-separator>
        <b-collapse
          id="registeration-over-time-section"
          accordion="registerOverTimeAccordionId"
          :visible="true"
          class="accordion__menu"
          @hide="registerOverTimeVisible = false"
          @show="registerOverTimeVisible = true"
        >
          <div class="card border-left-0 mt-2">
            <div class="card-body">
              <div class="mb-1">
                <div class="flex">
                  <div class="row">
                    <div class="col-lg-auto d-flex align-items-center">
                      <h5 class="card-title fw800" style="font-weight: bold;">Registrations Over Time</h5>
                    </div>
                    <div class="col-lg d-flex mb-2 flex-wrap justify-content-end align-items-center">
                      <b-btn
                        :hidden="isMobileScreen"
                        variant="primary"
                        :disabled="isRegistrationOverTimeRosterLoading"
                        @click.prevent="fetchRegistrationOverTimeRoster"
                        :style="`margin-top:${isMobileScreen ? '10px' : '0'}`"
                        class="btn-normal mb-2"
                      >
                        Export to Excel
                        <i v-if="isRegistrationOverTimeRosterLoading" class="fas fa-circle-notch fa-spin ml-1"></i>
                        <span v-else class="material-icons icon-16pt ml-1">file_download</span>
                      </b-btn>
                    </div>
                  </div>
                  <p class="text-70">
                    View and export the total registrations in selected program. Use the date filter above to narrow
                    down your selection based on registration date.
                  </p>
                  <div v-if="isMobileScreen" class="timeframe-select">
                    <v-select
                      id="time-frame"
                      class="form-control v-select-custom w-65 "
                      label="label"
                      v-model="timeFrame"
                      :reduce="item => item.value"
                      placeholder="Select Time Frame"
                      :options="timeFrameOptions"
                      :clearable="false"
                    >
                      <template #search="{ attributes, events }">
                        <input class="vs__search" :required="!timeFrame" v-bind="attributes" v-on="events" />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex align-items-center">
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                    </v-select>
                    <v-select
                      id="reg-status"
                      class="form-control v-select-custom w-65 mt-2"
                      label="label"
                      v-model="enrollStatus"
                      :reduce="item => item.value"
                      placeholder="Select enrollment status"
                      :options="enrollStatusOptions"
                    >
                      <template #search="{ attributes, events }">
                        <input class="vs__search" v-bind="attributes" v-on="events" />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex align-items-center">
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                    </v-select>
                    <v-select
                      id="payment-option"
                      class="form-control v-select-custom w-65 mt-2"
                      label="label"
                      v-model="paymentOption"
                      :reduce="item => item.value"
                      placeholder="Select payment option"
                      :options="paymentOptionOptions"
                    >
                      <template #search="{ attributes, events }">
                        <input class="vs__search" v-bind="attributes" v-on="events" />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex align-items-center">
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                    </v-select>
                    <b-btn
                      variant="primary"
                      :disabled="isRegistrationOverTimeRosterLoading"
                      @click.prevent="fetchRegistrationOverTimeRoster"
                      style="width: 100%"
                      :style="`margin-top:${isMobileScreen ? '10px' : '0'}`"
                      class="btn-normal mb-2"
                    >
                      Export to Excel
                      <i v-if="isRegistrationOverTimeRosterLoading" class="fas fa-circle-notch fa-spin ml-1"></i
                      ><span v-else class="material-icons icon-16pt ml-1">file_download</span>
                    </b-btn>
                  </div>

                  <div v-else>
                    <div class="d-flex mb-2" style="justify-content: space-between;">
                      <div class="d-flex flex-wrap">
                        <v-select
                          id="time-frame"
                          class="form-control v-select-custom w-65"
                          label="label"
                          v-model="timeFrame"
                          :reduce="item => item.value"
                          placeholder="Select Time Frame"
                          :options="timeFrameOptions"
                          :clearable="false"
                          :style="`width:120px`"
                        >
                          <template #search="{ attributes, events }">
                            <input class="vs__search" :required="!timeFrame" v-bind="attributes" v-on="events" />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-flex align-items-center">
                              <span>{{ option.label }}</span>
                            </div>
                          </template>
                        </v-select>
                        <v-select
                          id="reg-status"
                          class="form-control v-select-custom w-65 ml-2"
                          label="label"
                          v-model="enrollStatus"
                          :reduce="item => item.value"
                          placeholder="Select enrollment status"
                          :options="enrollStatusOptions"
                          :style="`width:210px`"
                        >
                          <template #search="{ attributes, events }">
                            <input class="vs__search" v-bind="attributes" v-on="events" />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-flex align-items-center">
                              <span>{{ option.label }}</span>
                            </div>
                          </template>
                        </v-select>
                        <v-select
                          id="payment-option"
                          class="form-control v-select-custom w-65 ml-2"
                          label="label"
                          v-model="paymentOption"
                          :reduce="item => item.value"
                          placeholder="Select payment option"
                          :options="paymentOptionOptions"
                          :style="`width:210px`"
                        >
                          <template #search="{ attributes, events }">
                            <input class="vs__search" v-bind="attributes" v-on="events" />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-flex align-items-center">
                              <span>{{ option.label }}</span>
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="chart-container mt-4" style="position: relative; ">
                        <div v-if="isChartLoading">
                          <div class="text-center mt-5 mb-4">
                            <b-spinner
                              class="align-middle mr-2"
                              :style="{ color: getLoggedInUser.linked_entity.primary_color }"
                            ></b-spinner>

                            <strong>Loading...</strong>
                          </div>
                        </div>
                        <canvas v-else id="registration-graph" class="chart-container"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
        <page-separator>
          <b-link v-b-toggle="'registeration-roster-section'" class="accordion__toggle p-0">
            <span class="flex">Program Roster</span>
            <md-icon class="accordion__toggle-icon">
              {{ registerRosterVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </md-icon>
          </b-link>
        </page-separator>
        <b-collapse
          id="registeration-roster-section"
          accordion="registrationRosterAccordionId"
          :visible="false"
          class="accordion__menu"
          @hide="registerRosterVisible = false"
          @show="registerRosterVisible = true"
        >
          <div class="card border-left-0 mt-2">
            <div class="card-body">
              <div class="d-flex mb-1">
                <div class="flex">
                  <div class="d-flex align-items-center mb-3">
                    <h5 class="card-title fw800" style="font-weight: bold;">Export Program Roster</h5>
                  </div>
                  <p class="text-70 mb-2">
                    View and export the list of students enrolled in selected program. Use the date filter above to
                    narrow down your selection based on class startdate.
                  </p>
                  <div class="d-flex justify-content-end mt-3">
                    <b-btn
                      variant="primary"
                      :disabled="isExportLoading"
                      @click.prevent="fetchRegistrationRosters"
                      style="width: 200px"
                      class="btn-normal"
                    >
                      Export Roster <i v-if="isExportLoading" class="fas fa-circle-notch fa-spin ml-1"></i
                      ><span v-else class="material-icons icon-16pt ml-1">file_download</span>
                    </b-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
        <page-separator>
          <b-link v-b-toggle="'general-report-section'" class="accordion__toggle p-0">
            <span class="flex">General Reporting</span>
            <md-icon class="accordion__toggle-icon">
              {{ generalReportVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </md-icon>
          </b-link>
        </page-separator>
        <b-collapse
          id="general-report-section"
          accordion="generalAccordionId"
          :visible="false"
          class="accordion__menu"
          @hide="generalReportVisible = false"
          @show="generalReportVisible = true"
        >
          <b-form class="col-md-12 px-0 page-section pt-0" @submit.prevent="onSubmit">
            <div class="card border-left-0">
              <div class="card-body">
                <div class="d-flex mb-1">
                  <div class="flex">
                    <div class="d-flex align-items-center">
                      <h5 class="card-title fw800" style="font-weight: bold;">
                        Export General Report
                      </h5>
                    </div>
                    <p class="text-70 mt-4 mb-0">
                      Export the list of students along with their details enrolled in selected program. Use the date
                      filter above to narrow down your selection based on registration date.
                    </p>
                    <page-separator
                      title="Background Related Information
          "
                    />

                    <div class="row">
                      <div
                        v-for="(item, index) in background_info"
                        :key="index"
                        class="col-lg-6 col-md-6 col-sm-12 clickable-item"
                      >
                        <div class="mt-4 mb-0 p-3 my-auto d-flex justify-content-start">
                          <b-form-checkbox v-model="apiData[item]">
                            <div class="d-flex">
                              <span style="font-size: 16px">{{ $t(`enrollmentAnalytics.${item}`) }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <page-separator
                      title="Payment Related Information
          "
                    />

                    <div class="row">
                      <div
                        v-for="(item, index) in payment_info"
                        :key="index"
                        class="col-lg-6 col-md-6 col-sm-12 clickable-item"
                      >
                        <div class="mt-4 mb-0 p-3 my-auto d-flex justify-content-start">
                          <b-form-checkbox v-model="apiData[item]">
                            <div class="d-flex">
                              <span style="font-size: 16px">{{ $t(`enrollmentAnalytics.${item}`) }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <page-separator
                      title="Career Related Information
          "
                    />

                    <div class="row">
                      <div
                        v-for="(item, index) in career_info"
                        :key="index"
                        class="col-lg-6 col-md-6 col-sm-12 clickable-item"
                      >
                        <div class="mt-4 mb-0 p-3 my-auto d-flex justify-content-start">
                          <b-form-checkbox v-model="apiData[item]">
                            <div class="d-flex">
                              <span style="font-size: 16px">{{ $t(`enrollmentAnalytics.${item}`) }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex justify-content-end">
                      <b-btn variant="primary" style="width: 200px" type="submit" class="btn-normal mb-2">
                        <i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i>
                        <span v-else
                          >Export Reporting<span class="material-icons icon-16pt ml-1">file_download</span></span
                        >
                      </b-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-form>
        </b-collapse>
      </div>
    </div>
    <div>
      <!-- Your modal trigger button goes here -->
    </div>
    <b-modal ref="myModal" title="Downloading Report" centered hide-footer @hide="hideModal">
      <span v-if="!fileUrl">
        <i
          style="font-size: 3rem"
          class="d-flex justify-content-center fas fa-circle-notch fa-spin text-primary mb-2"
        ></i>
        <span>Your file is being downloaded, we will notify you once it’s ready.</span>
        <p class="text-70 text-center">
          Note: You can safely move to another page. You will receive a notification shortly.
        </p>
      </span>
      <span v-else>
        <i
          style="font-size: 3rem"
          class="d-flex justify-content-center material-icons text-primary mb-2 clickable-item"
          @click.prevent="downloadGivenFile"
          >file_download</i
        >
        <span>Your file is ready to be downloaded. Click to download.</span>
      </span>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import vSelect from 'vue-select';
import Page from '@/components/Page.vue';
import { formatToAPIDate } from '../../../common/utils';
import PageSeparator from '@/components/Ui/PageSeparator.vue';
import { FmvAvatar } from 'fmv-avatar';
import { Chart } from 'chart.js';
import PageHeader from '@/components/Ui/PageHeader.vue';

export default {
  components: { DatePicker, vSelect, PageHeader, PageSeparator, FmvAvatar },
  extends: Page,

  data() {
    return {
      title: 'Registration Reporting',
      background_info: ['gender', 'age', 'language', 'ethnicity'],
      payment_info: ['tuition_fee_status', 'payment_option'],
      career_info: ['work_type', 'facility_interest'],
      areProgramsLoading: false,
      isExportLoading: false,
      isLoading: false,
      isProgramEmpty: false,
      generalReportVisible: false,
      registerRosterVisible: false,
      registerOverTimeVisible: true,
      connection: null,
      apiData: {
        gender: true,
        age: true,
        language: true,
        ethnicity: true,
        tuition_fee_status: true,
        payment_option: true,
        work_type: true,
        facility_interest: true,
      },
      filters: {
        dateRange: [],
        program: null,
      },
      allPrograms: [],
      bis: [],
      fileUrl: null,
      timeFrame: 'weekly',
      timeFrameOptions: [
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'yearly', label: 'Yearly' },
      ],
      enrollStatus: 'enrolled',
      enrollStatusOptions: [
        { value: 'enrolled', label: 'Enrolled' },
        { value: 'dropped', label: 'Dropped' },
        { value: 'transferred', label: 'Completed' },
      ],
      paymentOption: '',
      paymentOptionOptions: [
        { value: '', label: 'All Payment Options' },
        { value: 'pay_now', label: 'Pay Now' },
        { value: 'pay_later', label: 'Pay Later' },
        { value: 'free_plan', label: 'Free Plan' },
      ],
      isRegistrationOverTimeRosterLoading: false,
      chartData: {
        type: 'bar',
        data: {},
        options: this.chartOptions,
      },
      chartInstance: null,
      isChartLoading: false,
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser', 'getAuthToken']),
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Dashboard', active: true },
      ];
    },
    isMobileScreen() {
      return this.windowWidth <= 420;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        indexAxis: 'x',
        plugins: {
          legend: {
            position: 'top',
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      };
    },
  },

  methods: {
    ...mapActions('program', [
      'getAllPrograms',
      'getRegistrationRoster',
      'getRegistrationOverTimeRoster',
      'getRegistrationOverTimeGraphData',
    ]),
    ...mapActions('student', ['createAnalysisReport']),
    ...mapActions('fileDownload', ['downloadFile']),
    get,
    resetFile() {
      this.fileUrl = null;
    },
    openModal() {
      this.$refs.myModal.show();
    },
    hideModal() {
      this.resetFile();
      this.$refs.myModal.hide();
      this.closeConnection();
    },
    async downloadGivenFile({ removeTimestamp = true }) {
      const h = this.$createElement;
      this.makeToast({
        variant: 'primary',
        msg: h('span', [h('i', { class: 'fas fa-download mr-2' }), 'Downloading File']),
        toaster: 'b-toaster-bottom-left',
      });
      try {
        await this.downloadFile({ fileUrl: this.fileUrl, removeTimestamp });

        this.makeToast({
          variant: 'success',
          msg: h('span', [h('i', { class: 'fas fa-download mr-2' }), 'File Downloaded']),
          toaster: 'b-toaster-bottom-left',
        });
      } catch (e) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.hideModal();
    },
    hookUrlWS(timestamp) {
      this.connection = new WebSocket(
        `${process.env.VUE_APP_BACKEND_WS_URL}/ws/analytics/${this.getLoggedInUser.id}/${timestamp}/?token=${this.getAuthToken}`
      );

      this.connection.onmessage = event => {
        const data = JSON.parse(event.data).message;

        if (data.action === 'Create') {
          this.fileUrl = data.file_url;
        }
      };
      this.connection.onerror = () => {};
    },
    closeConnection() {
      if (this.connection) this.connection.close();
    },
    async fetchPrograms() {
      this.areProgramsLoading = true;

      const response = await this.getAllPrograms();
      this.allPrograms = response.data;

      this.areProgramsLoading = false;
    },
    async downloadCSV(url) {
      try {
        await this.downloadFile({
          fileUrl: url,
        });
        const h = this.$createElement;
        this.makeToast({
          variant: 'success',
          msg: h('span', [h('i', { class: 'fas fa-download mr-2' }), 'File Downloaded']),
          toaster: 'b-toaster-bottom-left',
        });
      } catch (error) {
        //
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
    },
    async fetchRegistrationRosters() {
      if (!this.filters.program) {
        this.isProgramEmpty = true;
        this.makeToast({ variant: 'danger', msg: 'Please select specific program' });
        return;
      }
      this.isProgramEmpty = false;
      this.isExportLoading = true;
      const response = await this.getRegistrationRoster({
        prog_id: this.filters.program,
        date_from: this.filters.dateRange[0],
        date_to: this.filters.dateRange[1],
      });
      this.downloadCSV(response.data.url);
      this.isExportLoading = false;
    },
    async onSubmit() {
      if (!this.filters.program) {
        this.isProgramEmpty = true;
        this.makeToast({ variant: 'danger', msg: 'Please select specific program' });
        return;
      }
      this.isProgramEmpty = false;
      this.isLoading = true;
      try {
        const data = {
          ...this.apiData,
          program: this.filters.program,
          date_from: this.filters.dateRange[0],
          date_to: this.filters.dateRange[1],
        };
        const res = await this.createAnalysisReport(data);
        this.hookUrlWS(res.timestamp);
        this.openModal();
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isLoading = false;
    },
    async fetchRegistrationOverTimeRoster() {
      this.isRegistrationOverTimeRosterLoading = true;
      const params = {
        prog_id: this.filters.program ? this.filters.program : null,
        date_from: this.filters.dateRange[0] ? this.filters.dateRange[0] : null,
        date_to: this.filters.dateRange[1] ? this.filters.dateRange[1] : null,
        time_frame: this.timeFrame,
        enroll_status: this.enrollStatus || '',
      };
      if (this.paymentOption) {
        params.payment_option = this.paymentOption;
      }
      const response = await this.getRegistrationOverTimeRoster(params);
      this.downloadCSV(response.data.url);
      this.isRegistrationOverTimeRosterLoading = false;
    },
    async fetchRegistrationGraphData() {
      const params = {
        prog_id: this.filters.program ? this.filters.program : null,
        date_from: this.filters.dateRange[0] ? this.filters.dateRange[0] : null,
        date_to: this.filters.dateRange[1] ? this.filters.dateRange[1] : null,
        time_frame: this.timeFrame,
        enroll_status: this.enrollStatus || '',
      };
      if (this.paymentOption) {
        params.payment_option = this.paymentOption;
      }
      const response = await this.getRegistrationOverTimeGraphData(params);
      return response.data;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    getDateRange(timeframeData) {
      if (timeframeData.date_from && timeframeData.date_to) {
        return `( ${timeframeData.date_from} - ${timeframeData.date_to} )`;
      }
      return '';
    },
    async fetchChartData() {
      this.isChartLoading = true;
      const timeframeData = await this.fetchRegistrationGraphData();
      const program = this.filters.program
        ? this.allPrograms.filter(item => item.id === this.filters.program)[0].title
        : null;
      this.chartData = {
        type: 'bar',
        data: {
          labels: timeframeData.labels,
          datasets: [
            {
              label: !program ? 'All Programs' : `${program}`,
              data: timeframeData.datasets,
              backgroundColor: this.getLoggedInUser.linked_entity.primary_color,
            },
          ],
        },
        options: {
          legend: {
            labels: {
              fontColor: this.getLoggedInUser.linked_entity.secondary_color,
            },
          },
          maintainAspectRatio: false,
          responsive: true,
          lineTension: 1,
          layout: { padding: { right: 25 } },
          scales: {
            yAxes: [
              {
                ticks: {
                  fontColor: this.getLoggedInUser.linked_entity.secondary_color,
                  beginAtZero: true,
                  padding: this.isMobileScreen ? 8 : 15,
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: this.getDateRange(timeframeData),
                  fontSize: 14,
                  fontStyle: 'italic',
                },
                ticks: {
                  fontColor: this.getLoggedInUser.linked_entity.secondary_color,
                  padding: this.isMobileScreen ? 8 : 15,
                },
              },
            ],
          },
        },
      };
      this.isChartLoading = false;
    },
    fetchAndUpdateChartData() {
      this.fetchChartData()
        .then(() => {
          const ctx = document.getElementById('registration-graph');
          if (this.chartInstance) {
            this.chartInstance.destroy();
          }

          this.chartInstance = new Chart(ctx, this.chartData);
        })
        .catch();
    },
  },
  watch: {
    'filters.program': 'fetchAndUpdateChartData',
    'filters.dateRange': 'fetchAndUpdateChartData',
    timeFrame: 'fetchAndUpdateChartData',
    enrollStatus: 'fetchAndUpdateChartData',
    paymentOption: 'fetchAndUpdateChartData',
  },
  async mounted() {
    this.fetchPrograms();
    this.filters.dateRange = [formatToAPIDate(moment().startOf('month')), formatToAPIDate(moment().endOf('month'))];
    this.fetchAndUpdateChartData();
  },
};
</script>
<style scoped>
.chart-container {
  width: 100%;
  height: 40vh;
}
@media only screen and (max-width: 700px) {
  .chart-container {
    width: 100%;
    height: 40vh;
  }
}
@media only screen and (max-width: 425px) {
  .chart-container {
    width: 250px;
    height: 250px;
  }
}
</style>
